export default __webpack_public_path__ + "static/media/car-gasoline.dae0d4fd.svg";